/**
 * Aeroveg — Delivery Day Coin-Flip Message
 * Loaded from theme.liquid so it runs on EVERY page load,
 * even when the cart is empty and the snippet hasn't rendered yet.
 */
(function () {
  var months = ['January','February','March','April','May','June','July',
                'August','September','October','November','December'];

  function getFirstDeliveryDate(dayName) {
    var dayMap = { Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4,
                   Friday: 5, Saturday: 6, Sunday: 0 };
    var selectedDay = dayMap[dayName];
    if (selectedDay === undefined) return null;

    var now      = new Date();
    var today    = now.getDay();
    var hour     = now.getHours() + now.getMinutes() / 60;
    var CUTOFF   = 15; // 3 pm

    // Deadline = day before delivery (Monday deadline = Saturday)
    var deadlineDay = (selectedDay === 1) ? 6
                    : (selectedDay === 0) ? 6
                    : selectedDay - 1;

    var daysToDelivery = (selectedDay - today + 7) % 7 || 7;
    var daysToDeadline = (deadlineDay - today + 7) % 7;

    var deadlinePassed = (selectedDay === 1 && today === 0) ||
                         (daysToDeadline === 0 && hour >= CUTOFF)  ||
                         (daysToDeadline >= daysToDelivery);

    var d = new Date(now);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + daysToDelivery + (deadlinePassed ? 7 : 0));
    return d;
  }

  function formatDate(d) {
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function stopFlip(component) {
    if (component._flipTimer) {
      clearInterval(component._flipTimer);
      component._flipTimer = null;
    }
  }

  function startFlip(component, a, b) {
    stopFlip(component);
    a.className = 'delivery-msg-line dmsg-a show';
    b.className = 'delivery-msg-line dmsg-b';
    component._flipCurrent = 0;

    component._flipTimer = setInterval(function () {
      if (component._flipCurrent === 0) {
        a.className = 'delivery-msg-line dmsg-a hide-up';
        setTimeout(function () {
          a.className = 'delivery-msg-line dmsg-a';
          b.className = 'delivery-msg-line dmsg-b show';
        }, 500);
        component._flipCurrent = 1;
      } else {
        b.className = 'delivery-msg-line dmsg-b hide-up';
        setTimeout(function () {
          b.className = 'delivery-msg-line dmsg-b';
          a.className = 'delivery-msg-line dmsg-a show';
        }, 500);
        component._flipCurrent = 0;
      }
    }, 3000);
  }

  function updateMessage(component, dayName) {
    var wrap  = component.querySelector('.delivery-msg-flip');
    var lineA = component.querySelector('.dmsg-a');
    var lineB = component.querySelector('.dmsg-b');
    if (!wrap || !lineA || !lineB) return;

    if (!dayName) {
      wrap.style.display = 'none';
      stopFlip(component);
      return;
    }

    var first   = getFirstDeliveryDate(dayName);
    var dateStr = first ? formatDate(first) : '';
    lineA.innerHTML = 'You\'ll receive your weekly delivery every <strong>' + dayName + '</strong>.';
    lineB.innerHTML = 'Your first delivery will be on <strong>' + dateStr + '</strong>.';
    wrap.style.display = 'block';
    startFlip(component, lineA, lineB);
  }

  // ── 1. Capture-phase listener on document ─────────────────────────────────
  // Fires BEFORE Shopify's own on:change handler — so we always get the event
  // even if Shopify later stops bubbling. Survives every cart re-render.
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('delivery-day-selector__select')) return;
    var component = e.target.closest('delivery-day-selector');
    if (component) updateMessage(component, e.target.value);
  }, true /* capture phase */);

  // ── 2. Check for pre-selected days (page load + after AJAX re-renders) ───
  function checkPreselected() {
    document.querySelectorAll('delivery-day-selector:not([data-day-ready])').forEach(function (component) {
      component.setAttribute('data-day-ready', '1');
      var select = component.querySelector('.delivery-day-selector__select');
      if (select && select.value) updateMessage(component, select.value);
    });
  }

  // ── 3. MutationObserver — watches for newly injected components ──────────
  // Debounced to let Shopify finish populating the new element's <select> value
  var observer = new MutationObserver(function () {
    clearTimeout(window._aerovegDayTimer);
    window._aerovegDayTimer = setTimeout(checkPreselected, 100);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    checkPreselected();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();